export default __webpack_public_path__ + "static/media/Hydrocon 1.6 ratio.7e170ebc.png";